/** Provenance for the exact configured aqueductglobalmaps21shp runtime layer.
 * ArcGIS item de71ba130eda4be195fa7564b0ca947e identifies the BucknellGIS
 * mirror of Aqueduct Global Maps 2.1. Its 2018 service edit is not a new
 * model edition or current observation. A 4.0 migration needs a new mapping.
 */
export const WRI_AQUEDUCT_SOURCE_LABEL = 'WRI Aqueduct Global Maps 2.1 (2015 release; BucknellGIS mirror, 2018)';
export const WRI_AQUEDUCT_SOURCE_URL = 'https://www.wri.org/data/aqueduct-global-maps-21-data';
export const WRI_AQUEDUCT_SOURCE_SCOPE = 'Historical basin-scale screening context; not current measured supply, a site allocation or water-rights confirmation.';
